import { CalendarEvent, CalendarEventKey } from 'mini-calendar-event-types';

/**
 * Gets the calendar event key.
 * @param event - Calendar event.
 * @returns calendar event key.
 */
export default function getCalendarEventKey(event: CalendarEvent): CalendarEventKey {
    return event.Key;
}
